import React, { Component } from "react";
import "./../styles/Tables.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { Button } from "./Button";
import { useState, useEffect } from "react";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Moment from "moment";
import DialogBoxClinical from "./DialogBoxClinical";

//class TableClinical extends Component {

const TableData = ({
  key1,
  data,
  cptcode_cr,
  description,
  unit_nr,
  anticipatedStartDate_DT,
  anticipatedEndtDate_DT,
  selectedValue,
  onSelect,
  //   setDecisionValue,
  taskStatus,
  cptData,
  setterMethod,
  decisionForReferToMD,
  setDecisionForReferToMD,
  noOfDeny,
  setNumberOfDeny,
  decisionarray,
  setdecisionarray,
  initalDecisonvalue,
  criteriaMet,
}) => {
  //   const [valueInDropDown, setValueinDropDown] = useState("1");
  const [selectedDecisionValue, setSelectedDecisionValue] =
    useState(initalDecisonvalue);

  console.log(
    "selectedDecisionValue",
    initalDecisonvalue,
    selectedDecisionValue
  );
  console.log("decisionForReferToMD", decisionForReferToMD);
  useEffect(() => {
    // let denyNos = noOfDeny;
    // if (denyNos <= 0) {
    //   if (selectedDecisionValue == "3") {
    //     denyNos++;
    //   } else denyNos = denyNos;
    // } else {
    //   if (selectedDecisionValue == "3") {
    //     denyNos++;
    //   } else if (selectedDecisionValue == "2") {
    //     denyNos--;
    //   }
    // }
    // console.log("No of deny", denyNos);
    // setNumberOfDeny(denyNos);
    // setDecisionForReferToMD(denyNos > 0 ? true : false);
    const arrayModified = decisionarray;
    arrayModified[key1] = +selectedDecisionValue;
    console.log(arrayModified);
    const isAtleastoneDeny = arrayModified.includes(3);
    setDecisionForReferToMD(isAtleastoneDeny);
    setDecisionForReferToMD(isAtleastoneDeny ? "Yes" : "No");
    onSelect(
      isAtleastoneDeny
        ? "3"
        : arrayModified.every((item) => item == "1")
        ? "1"
        : "2"
    );
    setdecisionarray([...arrayModified]);
  }, [selectedDecisionValue]);

  useEffect(() => {}, [decisionForReferToMD]);
  useEffect(() => {
    setSelectedDecisionValue(initalDecisonvalue);
  }, [initalDecisonvalue]);
  return (
    <>
      <tr key={key1}>
        <td>{cptcode_cr}</td>
        <td>{description}</td>
        <td>{unit_nr}</td>
        <td>{Moment(anticipatedStartDate_DT).format("MM/DD/YYYY")}</td>
        <td>{Moment(anticipatedEndtDate_DT).format("MM/DD/YYYY")}</td>
        <td>
          <select
            // value={selectedVal}
            value={selectedDecisionValue}
            onChange={(e) => {
              setSelectedDecisionValue(e.target.value);
            }}
          >
            <option value="1"></option>
            <option value="2">Criteria Met</option>
            <option value="3">Criteria Not Met</option>
          </select>
        </td>
        {/* <td>{props.taskStatus}</td> */}
        {taskStatus != 7 && taskStatus != 8 && taskStatus != 19 ? (
          <td>
            <DialogBoxClinical
              className="buttonTbl"
              ButtonID="BtnCPT"
              cptData={cptData}
              rowID={key1}
              setterMethod={setterMethod}
            >
              <i className="fas fa-trash"></i>
            </DialogBoxClinical>
          </td>
        ) : (
          ""
        )}
      </tr>
    </>
  );
};
const TableClinical = (props) => {
  console.log("data from half box ", props.cptData);
  const [open, setOpen] = React.useState(false);
  const [rowID, setRowID] = useState("");
  const [cptDescription, setCPTDescription] = useState();
  const [cptCode, setCPTCode] = useState();
  const [cptunits, setCPTUnits] = useState(1);
  const [cptCodeID, setCPTCodeID] = useState();
  const [servicedateto, setserviceTo] = useState(false);
  const [servicedatefrom, setserviceFrom] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptionValue, setSelectedOptionValue] = useState("");

  const [decisionForReferToMD, setDecisionForReferToMD] = useState(false);
  const [noOfDeny, setNumberOfDeny] = useState(0);
  const [decisionarray, setdecisionarray] = useState(() =>
    [...Array(props.cptData.length)].fill(1)
  );
  console.log(decisionarray);
  var setterMethod;

  console.log(">>>>>-------->", decisionForReferToMD == false ? "no" : "yes");
  setterMethod = props.setCPTData;

  const handleClickOpen = (index) => {
    console.log("index ", index);
    setOpen(true);
    setRowID(index);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setDecisionValue = (data, setstate) => {
    setstate(data.target.value);
    setSelectedOptionValue(data.target.value);
  };

  console.log(props.selectedValue);

  // render(){
  //console.log('data from half box ', this.props.cptData);
  return (
    <div className="tblDiv">
      <table className="tblDisplay" style={{ width: "150%" }}>
        <thead>
          <tr>
            <th>CPT Code</th>
            <th>Description</th>
            <th>Unit</th>
            <th>Service From</th>
            <th>Service To</th>
            <th>Decision</th>
            {/* <th>Value</th> */}
            {props.taskStatus != 7 &&
            props.taskStatus != 8 &&
            props.taskStatus != 19 ? (
              <th colSpan="2"></th>
            ) : (
              ""
            )}
          </tr>
        </thead>
        <tbody>
          {/* {this.props.cptData.map(data => ( */}
          {props.cptData.map((data, index) => {
            console.log(props.initalDecisonvalue);
            return (
              <>
                <TableData
                  key1={index}
                  data={data}
                  cptcode_cr={data.CPTCode_CR}
                  description={data.Description}
                  unit_nr={data.Unit_NR}
                  anticipatedStartDate_DT={data.AnticipatedStartDate_DT}
                  anticipatedEndtDate_DT={data.AnticipatedEndtDate_DT}
                  selectedValue={props.selectedValue}
                  onSelect={props.onSelect}
                  setDecisionValue={setDecisionValue}
                  taskStatus={props.taskStatus}
                  cptData={props.cptData}
                  setterMethod={setterMethod}
                  setDecisionForReferToMD={setDecisionForReferToMD}
                  decisionForReferToMD={decisionForReferToMD}
                  noOfDeny={noOfDeny}
                  setNumberOfDeny={setNumberOfDeny}
                  decisionarray={decisionarray}
                  setdecisionarray={setdecisionarray}
                  initalDecisonvalue={props.initalDecisonvalue}
                  criteriaMet={props.criteriaMet}
                ></TableData>
                {/* <tr key={index}>
              <td>{data.CPTCode_CR}</td>
              <td>{data.Description}</td>
              <td>{data.Unit_NR}</td>
              <td>
                {Moment(data.AnticipatedStartDate_DT).format("MM/DD/YYYY")}
              </td>
              <td>
                {Moment(data.AnticipatedEndtDate_DT).format("MM/DD/YYYY")}
              </td>
              <td>
                <select
                  value={props.selectedValue}
                  onChange={(e) => {
                    setDecisionValue(e, props.onSelect);
                  }}
                >
                  <option value="1"></option>
                  <option value="2">Approved</option>
                  <option value="3">Deny</option>
                </select>
              </td> */}
                {/* <td>{props.taskStatus}</td> */}
                {/* {props.taskStatus != 7 &&
              props.taskStatus != 8 &&
              props.taskStatus != 9 ? (
                <td>
                  <DialogBoxClinical
                    className="buttonTbl"
                    ButtonID="BtnCPT"
                    cptData={props.cptData}
                    rowID={index}
                    setterMethod={setterMethod}
                  >
                    <i className="fas fa-trash"></i>
                  </DialogBoxClinical>
                </td>
              ) : (
                ""
              )}
            </tr> */}
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableClinical;
